<template>
  <v-container class="pa-30 ma-30 mt-16 pl-0 pr-0">
    <v-row class="my-30 pa-30" style="direction: ltr">
      <div v-for="(product, i) in productItems" :key="i">
        <v-card class="my-20" max-width="275" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">{{ product.title }}</div>
              <v-list-item-title class="text-h5 mb-1"> {{ product.title }} </v-list-item-title>
              <v-list-item-subtitle>{{ product.displayTitle }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
          </v-list-item>
          <v-card-actions>
            <v-btn
              outlined
              rounded
              text
              @click="redirectMe(product.type, product.code, product.term)"
            >
              Select
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import routeMixin from '@/_core/mixins/routeMixin.js';
import { productItems } from '@/plugins/appSettings';

export default {
  name: 'Home',
  mixins: [routeMixin],
  data() {
    return {
      productItems,
    };
  },
  methods: {
    async redirectMe(type, code, term) {
      this.$router.push({
        params: {
          applicationName: 'fede',
          productType: type,
          productCode: code,
          productTerm: term,
          action: 'customerOnboarding',
        },
      });
    },
  },
};
</script>
